// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__tisq9"};